import { Component, NgZone, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { DataService } from 'src/app/services/data.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import { FirebaseStorageService } from 'src/app/services/firebase-storage.service';
import { EditSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ConfirmReservationDialogComponent } from '../dialogs/confirm-reservation-dialog/confirm-reservation-dialog.component';
import { MatDialog } from '@angular/material/dialog';

import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.sass']
})
export class ProductsComponent implements OnInit {
  public editSettings: EditSettingsModel = { allowEditing: false, allowAdding: true, allowDeleting: true, mode: 'Normal', newRowPosition: "Bottom" };
  public toolbar: ToolbarItems[];
  public data: object[] = []
  public selectedLanguageFlag: string = 'es';
  productsListSubs: Subscription;
  products: any;
  productForm: FormGroup;
  isList: boolean = true;
  isNew: boolean = true;
  modification_date: string;
  creation_date: string;
  logo_url: string;
  type_accept: string;
  selectedFiles: File;
  pageSize: number = 100;
  pageIndex: number = 0;
  // catalogsListSubs: Subscription;
  // catalogs: any;

  public gifts: any

  displayedColumns: string[] = ['name_es', 'name_en', 'name_cat', 'available', 'modification_date', 'actions'];
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, {}) sort: MatSort;


  // TODO Check if causes no conflicts
  showProductDescriptionProgressBar: boolean = true;
  showProductTableProgressBar: boolean = true;

  idCounter: number = 1;
  newItemForm: FormGroup;
  editItemForm: FormGroup;
  productDescriptionForm: FormGroup;

  editModeState: any = {
    id: '',
    open: false,
    newEntry: false,
  }

  descriptionTableColumns: string[] = ["unit", "description_es", "description_cat", "description_en", 'actions'];

  constructor(
    public dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    public firebaseStorageService: FirebaseStorageService,
    public dialog: MatDialog,
    private snackbar: MatSnackBar
  ) {
    this.newItemForm = formBuilder.group({
      unit: new FormControl(''),
      description_es: new FormControl('', Validators.required),
      description_cat: new FormControl('', Validators.required),
      description_en: new FormControl('', Validators.required),
    })

    this.editItemForm = formBuilder.group({
      unit: new FormControl(''),
      description_es: new FormControl('', Validators.required),
      description_cat: new FormControl('', Validators.required),
      description_en: new FormControl('', Validators.required),
    })


    this.productDescriptionForm = formBuilder.group({
      unit: new FormControl(''),
      description_es: new FormControl('', Validators.required),
      description_cat: new FormControl('', Validators.required),
      description_en: new FormControl('', Validators.required),
    })

  }

  // public getCatalogs() {
  //   this.catalogsListSubs = this.dataService
  //     .getCatalogs()
  //     .subscribe(res => {

  //       this.catalogs = res;
  //       this.catalogs = [{ 'id': "", 'name': "" }].concat(this.catalogs)
  //     },
  //       console.error
  //     );
  // }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    if(localStorage.getItem('products'))
    {
      let data = JSON.parse(localStorage.getItem('products'))

      this.pageSize = data.pageSize
      this.pageIndex = data.page-1
    }
  }


  ngOnInit() {
    this.toolbar = ['Add', 'Delete', 'Update', 'Cancel'];
    // this.data = [{"unit":5, "description_es":"Descripción", "description_cat":"Descripciò","description_en":"Description"}, {"unit":3, "description_es":"Producto", "description_cat":"Producte","description_en":"Product"}]
    this.type_accept = '.jpeg, .png, .jpg';
    this.dataService.getRole().subscribe(res => {
      if ((res != 'superadmin') && (res != 'admin')) {
        this.router.navigate(['/welcome']);
      }

    });
    // this.catalogs = this.getCatalogs();

    this.productForm = this.formBuilder.group({
      id: new FormControl(0, Validators.required),
      name_es: new FormControl('', Validators.required),
      name_cat: new FormControl('', Validators.required),
      name_en: new FormControl('', Validators.required),
      // description: new FormControl('', Validators.required),
      // priority: new FormControl(0, Validators.required),
      value: new FormControl(0, Validators.required),
      value_tax: new FormControl(0, Validators.required),
      available: new FormControl(false, Validators.required),
      not_send_to_lab: new FormControl(false, Validators.required),
      individual_photo: new FormControl(false, Validators.required),
      multiple_photo: new FormControl(false, Validators.required),
      class_group_photo: new FormControl(false, Validators.required),
      funny_photo: new FormControl(false, Validators.required),
      product_image: new FormControl(''),
      // downloadable: new FormControl(false, Validators.required),
      // catalogue: new FormControl('', Validators.required)
      is_gift: new FormControl(false, Validators.required),
      add_gift: new FormControl(false, Validators.required),
      gift_list: new FormControl('', Validators.required)
    });


    // this.products = this.getProducts();
    // this.routeSub = 



    this.route.params.subscribe(params => {
      this.dataService.getProducts('list').subscribe(products => {
        this.products = products;
        this.dataSource.data = this.products;
        this.showProductTableProgressBar = false;
      });
      if (params.id) {

        this.getGifts()
        
        this.isList = false;
        if (params.id != 'new') {
          this.isNew = false;
          this.productsListSubs = this.dataService
            .getProduct(params.id) //cambiar por id en el html
            .subscribe(res => {
              
              this.products = res;

              if(!this.route.toString().includes('duplicate')) 
              {
                this.productForm.controls["id"].setValue(this.products.id);
                this.productForm.controls["name_es"].setValue(this.products.name_es);
                this.productForm.controls["name_cat"].setValue(this.products.name_cat);
                this.productForm.controls["name_en"].setValue(this.products.name_en);
              }

              this.productForm.controls["product_image"].setValue(this.products.product_image);

              this.data = JSON.parse(this.products.description);
              let dataWithIdParameter = [];
              this.data.forEach((des: any) => {
                let description = {
                  id: this.idCounter,
                  unit: des.unit,
                  description_es: des.description_es,
                  description_cat: des.description_cat,
                  description_en: des.description_en
                }
                dataWithIdParameter.push(description)
                this.idCounter += 1;
              })
              this.data = dataWithIdParameter
              this.showProductDescriptionProgressBar = false;

              // this.productForm.controls["priority"].setValue(this.products.priority);

              this.productForm.controls["individual_photo"].setValue(this.products.individual_photo);
              this.productForm.controls["multiple_photo"].setValue(this.products.multiple_photo);
              this.productForm.controls["class_group_photo"].setValue(this.products.class_group_photo);
              this.productForm.controls["funny_photo"].setValue(this.products.funny_photo);
              this.productForm.controls["value"].setValue(this.products.value);
              this.productForm.controls["value_tax"].setValue(this.products.value_tax);
              this.productForm.controls["available"].setValue(this.products.available);
              this.productForm.controls["not_send_to_lab"].setValue(this.products.not_send_to_lab);
              this.productForm.controls["is_gift"].setValue(this.products.is_gift);
              if(this.products.gift_list) {
                let gift_list = this.products.gift_list.split(',').map(x => parseInt(x, 10))
                console.log(gift_list)
                this.productForm.controls["add_gift"].setValue(true);
                this.productForm.controls["gift_list"].setValue(gift_list);
              }
              // this.productForm.controls["downloadable"].setValue(this.products.downloadable);
              // this.productForm.controls["catalogue"].setValue(this.products.catalogue._flat_path[1].toString());


              this.creation_date = this.products.creation_date;
              this.modification_date = this.products.modification_date;
            },
              console.error
            );
        }
        else {
          this.isNew = true;
          this.showProductDescriptionProgressBar = false;
        }


      }
      else {
        this.isList = true;
      }
    });
  }

  selectFile(event) {
    this.selectedFiles = event.target.files;
  }

  goTo(productID: string) {
    let data = {}
    data['page'] = this.paginator.pageIndex+1
    data['pageSize'] = this.paginator.pageSize
    localStorage.setItem('products', JSON.stringify(data))
    this.router.navigateByUrl(`product/${productID}`);
  }

  applyFilter(text: any) {
    const filterValue = (text.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  newProduct() {
    this.router.navigateByUrl(`product/new`);
  }

  setGiftDefault() {
    if(this.productForm.controls["is_gift"].value) {
      console.log(this.productForm.controls["is_gift"].value)
      this.productForm.controls["available"].setValue(true)
      this.productForm.controls["not_send_to_lab"].setValue(true)
      this.productForm.controls['individual_photo'].setValue(false)
      this.productForm.controls['multiple_photo'].setValue(false)
      this.productForm.controls['class_group_photo'].setValue(false)
      this.productForm.controls['funny_photo'].setValue(false)
    }
  }

  saveProduct() {
    var params = {};
    params['name_es'] = this.productForm.controls["name_es"].value;
    params['name_cat'] = this.productForm.controls["name_cat"].value;
    params['name_en'] = this.productForm.controls["name_en"].value;
    params['id'] = this.productForm.controls["id"].value;


    // The following takes every object from the this.data array and removes
    // the unnecesary id parameter from it before uploading it to datastore.
    let descriptionDataList = [];

    this.data.forEach((element: any) => {
      let description = {
        description_cat: element.description_cat,
        description_en: element.description_en,
        description_es: element.description_es,
        unit: element.unit
      };

      descriptionDataList.push(description);
    })


    params['description'] = JSON.stringify(descriptionDataList);

    // params['priority'] = this.productForm.controls["priority"].value;

    params['individual_photo'] = this.productForm.controls["individual_photo"].value;
    params['multiple_photo'] = this.productForm.controls["multiple_photo"].value;
    params['class_group_photo'] = this.productForm.controls["class_group_photo"].value;
    params['funny_photo'] = this.productForm.controls["funny_photo"].value;
    params['value'] = this.productForm.controls["value"].value;
    params['value_tax'] = this.productForm.controls["value_tax"].value;
    params['available'] = this.productForm.controls["available"].value;
    params['not_send_to_lab'] = this.productForm.controls["not_send_to_lab"].value;
    params['is_gift'] = this.productForm.controls["is_gift"].value;
    params['gift_list'] = this.productForm.controls["gift_list"].value && this.productForm.controls["add_gift"].value && !this.productForm.controls["is_gift"].value? String(this.productForm.controls["gift_list"].value) : '';
    // params['downloadable'] = this.productForm.controls["downloadable"].value;
    // params['catalogue'] = this.productForm.controls["catalogue"].value;

    if (params['name_es'] == '') {
      this.translate.get('alerts.name_required').subscribe((res: string) => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
      })
      return false;
    }
    if (params['name_cat'] == '') {
      this.translate.get('alerts.name_required').subscribe((res: string) => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
      })
      return false;
    }
    if (params['name_en'] == '') {
      this.translate.get('alerts.name_required').subscribe((res: string) => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
      })
      return false;
    }
    if ((params['individual_photo'] == false) && (params['multiple_photo'] == false) && (params['class_group_photo'] == false) && (params['funny_photo'] == false)) {
      this.translate.get('alerts.type_required').subscribe((res: string) => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
      })
      return false;
    }
    // if (params['catalogue'] == '') {
    //   this.translate.get('alerts.catalogue_required').subscribe((res: string) => {
    //     alert(res);
    //   })
    //   return false;
    // }

    if (this.selectedFiles) {
      const filePath = 'products/' + params['name_es'];
      const storageRef = this.firebaseStorageService.referenciaCloudStorage(filePath);
      const uploadTask = this.firebaseStorageService.tareaCloudStorage(filePath, this.selectedFiles[0]);
      uploadTask.snapshotChanges().pipe(
        finalize(() => {
          storageRef.getDownloadURL().subscribe(downloadURL => {
            params['url'] = filePath
            // params['url'] = downloadURL;

            this.dataService.saveProduct(params).subscribe(data => {
              
              if (data == '') {
                this.router.navigateByUrl(`products`);
              }
              else {
                // throw new Error (data)
                this.translate.get('alerts.save_product_error').subscribe((res: string) => {
                  this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
                })
              }
            })
          });
        })
      ).subscribe();
    }
    else {
      params['url'] = this.products.url? this.products.url : ''
      this.dataService.saveProduct(params).subscribe(data => {
        
        if (data == '') {
          this.router.navigateByUrl(`products`);
        }
        else {
          // throw new Error (data)
          this.translate.get('alerts.save_product_error').subscribe((res: string) => {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
          })
        }
      })
    }

  }

  setGiftType(isGift: boolean, type) {
    if (!isGift) {
      return
    }

    switch (type) {
      case 'individual_photo': {
        this.productForm.controls['multiple_photo'].setValue(false)
        this.productForm.controls['class_group_photo'].setValue(false)
        this.productForm.controls['funny_photo'].setValue(false)
        break
      }
      case 'multiple_photo': {
        this.productForm.controls['individual_photo'].setValue(false)
        this.productForm.controls['class_group_photo'].setValue(false)
        this.productForm.controls['funny_photo'].setValue(false)
        break
      }
      case 'class_group_photo': {
        this.productForm.controls['multiple_photo'].setValue(false)
        this.productForm.controls['individual_photo'].setValue(false)
        this.productForm.controls['funny_photo'].setValue(false)
        break
      }
      case 'funny_photo': {
        this.productForm.controls['multiple_photo'].setValue(false)
        this.productForm.controls['class_group_photo'].setValue(false)
        this.productForm.controls['individual_photo'].setValue(false)
        break
      }
    }
  }

  getGifts() {
    let lang = this.translate.currentLang

    console.log(lang)

    let params = { "lang": lang }

    let sub = this.dataService.getGifts(params).subscribe((res: any) => {
      if(res) {
        this.gifts = res
        console.log(res)
      }

      sub.unsubscribe()
    })
  }


  duplicateProduct(productID: string) {
    this.router.navigateByUrl(`product/${productID}/duplicate`);
  }

  // Change deleted param of product to "true"
  deleteProduct(productID: string) {

    // We use ID to know which one to "delete"
    let params = { prod_id: productID }


    // We create content for the confirm action popup

    let popup_content = {}

    this.translate.get('alerts.atention').subscribe(res => {
      popup_content['title'] = res;
    })

    this.translate.get('alerts.confirm_product_delete').subscribe(res => {
      popup_content['message'] = res;
    })

    this.translate.get('buttons.ok').subscribe(res => {
      popup_content['ok_txt'] = res;
    })

    // We throw a confirm action popup
    let dialogRef = this.dialog.open(ConfirmReservationDialogComponent, {
      data: {
        title: popup_content['title'],
        message: popup_content['message'],
        ok_txt: popup_content['ok_txt']
      }
    }).beforeClosed().subscribe(res => {

      if (res) {

        // Call backend to change param of deleted to "true"
        this.dataService.deleteProduct(params).subscribe(data => {

          // If succesfull
          if (data.status == "success") {

            this.showProductTableProgressBar = true;

            // We reload the products displayed in the table
            this.dataService.getProducts('list').subscribe(products => {
              this.products = products;
              this.dataSource.data = this.products;
              this.showProductTableProgressBar = false;
            });

          }

        })


      }


    })

  }

  // Method for Drag and drop feature list update
  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.data, event.previousIndex, event.currentIndex);
    this.data = [...this.data];
  }


  productDescriptionHandler(fg: FormGroup, id: any = false) {

    if (!fg.valid) throw new Error('Invalid input');

    // If ID exists, we are editing an existing item description / else we are creating a new one
    if (id) {

      this.data.forEach((element: any) => {
        if (element.id == id) {
          element.unit = fg.value.unit;
          element.description_es = fg.value.description_es;
          element.description_cat = fg.value.description_cat;
          element.description_en = fg.value.description_en;
        }
      })

      this.closeEditMode()

    } else {

      let newItemList = this.data

      let newItem = {
        id: this.idCounter,
        unit: isNaN(parseInt(fg.value.unit)) ? null : fg.value.unit,
        description_es: fg.value.description_es,
        description_cat: fg.value.description_cat,
        description_en: fg.value.description_en,

      }

      this.idCounter += 1;

      newItemList.push(newItem);

      this.data = [...newItemList]

      this.closeEditMode()

    }


  }



  // Opens edit mode for product description list
  openEditMode(item: any = false) {

    if (item) {

      this.editModeState.newEntry = false

      this.productDescriptionForm = this.formBuilder.group({
        unit: new FormControl(item.unit),
        description_es: new FormControl(item.description_es, Validators.required),
        description_cat: new FormControl(item.description_cat, Validators.required),
        description_en: new FormControl(item.description_en, Validators.required),
      })

      this.editModeState.id = item.id;
      this.editModeState.open = true;

    } else {

      this.editModeState.id = ""

      this.productDescriptionForm = this.formBuilder.group({
        unit: new FormControl(''),
        description_es: new FormControl('', Validators.required),
        description_cat: new FormControl('', Validators.required),
        description_en: new FormControl('', Validators.required),
      })

      this.editModeState.newEntry = true
      this.editModeState.open = true

    }



  }


  closeEditMode() {
    this.editModeState.id = "";
    this.editModeState.open = false;
    this.editModeState.newEntry = false;
  }

  // Deletes item from product description list
  deleteItem(item: any) {

    if (item.id == this.editModeState.id) {
      this.editModeState.id = "";
      this.editModeState.open = false;
    }

    let newDataSource = []

    this.data.forEach((element: any) => {
      if (item.id != element.id) {
        newDataSource.push(element)
      }
    })


    this.data = newDataSource

  }


}